import { exit_stream, fetchResponses, checkItemExists, updateMetaTags, loadReveal } from "../script.js";
import { useEffect } from 'react';
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import KindleSlides from "../Util/KindleSlides.js";

export default function About(props) {
  const navigate = useNavigate();
  let userInputField;
  let loadingIndicator;
  let spinnerOverlay;

  useEffect(() => {
    userInputField = document.getElementById('user-input');
    loadingIndicator = document.getElementById('loading');
    spinnerOverlay = document.getElementById('spinner-overlay');

    // Handle button click
    document.getElementById('btn-query').addEventListener('click', handleUserInput);

    // Handle Enter key press
    userInputField.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        handleUserInput(event);
      }
    });

    if (queryParam) {
      document.title = `6 Hats - ${decodeURIComponent(queryParam)}`;
      userInputField.value = decodeURIComponent(queryParam);
      userInputField.classList.add('loading');
      loadingIndicator.style.display = 'inline';
      loadingIndicator.style.margin = 'auto';
      spinnerOverlay.style.display = 'inline';
      spinnerOverlay.style.margin = 'auto';
      fetchResponses(queryParam, loadingIndicator, spinnerOverlay, userInputField, navigate);
    }
    const arrowButton = document.querySelector(".arrow-button");
    updateMetaTags();
    
    if (!props.loggedInEmail) {
      // No valid stream
      exit_stream();
    }
  }, []);

  let response_1 = "6hats AI provides mobile-friendly, bite-sized responses that get straight to the point. Simply type your query and explore six clear structured aspects of the topic.";
  let response_2 = "6Hats acts as your understanding assistant, generating tailored questions and responses instantly for complex topics. Press the <b>Wizard Hat</b> to dive deeper and save insights to your <b>Knowledge Vault</b>.";
  let response_3 = "Explore any topic with six diverse perspectives for a richer, multi-faceted understanding. Use the <b>One Query, Six Voices</b> slider to unlock these unique viewpoints.";
  let response_4 = "To add depth to AI responses, the response can be saved to an expert’s stream. When the <b>search button is clicked, 6Hats matches the response</b> with similar questions from expert streams to follow.";
  let response_5 = "Enhance AI responses by saving them to an expert’s stream, where experts and users can add depth through their own edits and comments.";
  let response_6 = "Clicking <b>Upgrade to Pro</b> on the accounts page lets any user become an expert. Users will save to your stream based on its reputation, including user count, upvotes, and comments. Expert streams add value, enhancing the user experience and promoting additional services.";

  let about_6hats = [
    `Get to the Point: ${response_1}`,
    `Understanding Assistant: ${response_2}`,
    `One Query, Six Voices: ${response_3}`,
    `6hats Streams: ${response_4}`,
    `Experts bring nuance: ${response_5}`,
    `6hats Pro: ${response_6}`,
  ]

  const handleUserInput = async function (event) {
    event.preventDefault();
    const userInput = userInputField.value.trim();
    const NAMESPACE_URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8'; // UUIDv5 Namespace URL
    /*global uuid*/
    const guid = uuid.v5(userInput, NAMESPACE_URL);

    if (userInput !== '') {
      spinnerOverlay.style.display = 'flex';
      const encodedQuery = encodeURIComponent(userInput);
      const responseSlidesPresent = document.getElementById('response-slides').childElementCount > 0;

      if (responseSlidesPresent) {
        await fetchResponses(encodedQuery, loadingIndicator, spinnerOverlay, userInputField, navigate);
      } else {
        const itemExists = await checkItemExists(guid);
        if (itemExists) {
          navigate(`/?item=${guid}`, { replace: true });
        } else {
          await fetchResponses(encodedQuery, loadingIndicator, spinnerOverlay, userInputField, navigate);
        }
      }
    }
  };

  const urlParams = new URLSearchParams(window.location.search);
  const queryParam = urlParams.get('query');

  return (
    <>
      <div className="content-div">
        {about_6hats.length > 0 ?
          <KindleSlides slides={about_6hats} /> : null
        }

        {/* Text box container fixed at the bottom of the page*/}
        <div className="textbox-container">
          <textarea id="user-input" rows="2" placeholder="6Hats – AI answers. You save. Experts bring nuance."></textarea>
          {/* Upward arrow button on the right side */}
          <button className="arrow-button" id="btn-query">
            <FontAwesomeIcon icon={faArrowUp} />
          </button>
        </div>

        {/* TODO Show during loading */}
        <span id="loading" className="center-screen" style={{ display: "none" }}>Loading...</span>

        {/* Spinner overlay */}
        <div id="spinner-overlay" className="spinner-overlay" style={{ display: "none" }}>
          <i className="fas fa-spinner fa-spin fa-3x" style={{ color: "gray" }}></i>
        </div>
      </div>
    </>
  );
}